const autosaveTimers = window.storyAutosaveTimers = window.storyAutosaveTimers || {};

export function registerAutosaveHooks() {
    document.querySelectorAll('.btn[data-rating]').forEach(function (btn) {
        btn.addEventListener('click', function () {
            const storyId = this.dataset.storyId;
            const rating = parseInt(this.dataset.rating);
            const hiddenField = document.getElementById('rating_' + storyId);
            const btnGroup = this.parentElement;

            console.log('Rating changed to', rating, 'for story', storyId);

            // Toggle rating - if clicking the same rating, clear it
            if (hiddenField.value != null && parseInt(hiddenField.value) === rating) {
                hiddenField.value = null;
                btnGroup.querySelectorAll('.btn').forEach(b => b.classList.remove('active'));
                console.log('Rating cleared');
            } else {
                hiddenField.value = rating;
                // Update active state for all buttons
                btnGroup.querySelectorAll('.btn').forEach(function (b) {
                    if (parseInt(b.dataset.rating) <= rating) {
                        console.log('Rating button', b.dataset.rating, 'activated');
                        b.classList.add('active');
                    } else {
                        console.log('Rating button', b.dataset.rating, 'deactivated');
                        b.classList.remove('active');
                    }
                });
            }

            // Trigger autosave immediately on rating change
            autosaveStoryMeta(storyId).then(r => console.log('Autosave triggered on rating change'));
        });
    });

    document.querySelectorAll('.story-notes-input[data-story-id]').forEach(function (notesInput) {
        const storyId = notesInput.dataset.storyId;
        if (notesInput) {
            notesInput.addEventListener('input', function () {
                scheduleAutoSave(storyId, notesInput);
            });
            notesInput.addEventListener('blur', function () {
                if (autosaveTimers[storyId]) {
                    clearTimeout(autosaveTimers[storyId]);
                }
                if (isStoryMetaChanged(storyId)) {
                    autosaveStoryMeta(storyId).then(r => console.log('Autosave triggered on blur'));
                }
            });
        }
    });
}

function scheduleAutoSave(storyId) {
    if (autosaveTimers[storyId]) {
        // Save already scheduled.
        return;
    }

    if (isStoryMetaChanged(storyId)) {
        // Set status to unsaved
        updateSaveStatus(storyId, 'pending');

        // Set new timer for 3 seconds
        autosaveTimers[storyId] = setTimeout(async function () {
            await autosaveStoryMeta(storyId);
        }, 3000);
    } else {
        // No changes, so set status to saved
        updateSaveStatus(storyId, 'saved');
    }
}

function updateSaveStatus(storyId, status, statusDetail) {
    const statusEl = document.querySelector(`.story-save-status[data-story-id="${storyId}"] i`);
    if (!statusEl) return;

    statusEl.className = ''; // Clear existing classes

    if (status === 'saved') {
        statusEl.className = 'fa fa-check-circle text-success';
        statusEl.title = 'Saved' + (statusDetail ? ' at ' + statusDetail : '');
    } else if (status === 'pending') {
        statusEl.className = 'fa fa-circle-o text-muted';
        statusEl.title = 'Not yet saved';
    } else if (status === 'error') {
        statusEl.className = 'fa fa-exclamation-triangle text-danger';
        statusEl.title = 'Error' + (statusDetail ? ': ' + statusDetail : '');
    } else if (status === 'saving') {
        statusEl.className = 'fa fa-refresh fa-spin text-muted';
        statusEl.title = 'Saving...';
    }
}

function isStoryMetaChanged(storyId) {
    const notesInput = document.getElementById(`notes_${storyId}`);
    const originalValue = notesInput.defaultValue;
    const newValue = notesInput.value;
    return originalValue !== newValue;
}

async function autosaveStoryMeta(storyId) {
    clearTimeout(autosaveTimers[storyId]);
    autosaveTimers[storyId] = null;
    const noteField = document.getElementById(`notes_${storyId}`);
    const formData = new FormData();
    formData.append('story_id', document.getElementById(`story_id_${storyId}`).value);
    formData.append('from', document.getElementById(`from_${storyId}`).value);
    formData.append('rating', document.getElementById(`rating_${storyId}`).value);
    formData.append('notes', noteField.value);

    // Get CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    updateSaveStatus(storyId, 'saving');
    const response = await fetch('/user/story_thought', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'X-CSRF-Token': csrfToken
        },
        body: formData
    });
    console.log('Autosave response:', response, response.status, response.statusText, response.headers.get('Content-Type'));
    if (response.ok) {
        const now = new Date();
        const locale = navigator.language || navigator.userLanguage || 'en-US';
        const timeStr = now.toLocaleTimeString(locale, {hour: 'numeric', minute: '2-digit'});
        updateSaveStatus(storyId, 'saved', timeStr);
        noteField.defaultValue = noteField.value;
        // In case of changes since last save, schedule another save in 3 seconds,
        scheduleAutoSave(storyId);
    } else if (response.status === 422 && response.headers.get('Content-Type').startsWith('application/json')) {
        updateSaveStatus(storyId, 'error', (await response.json())['error']);
    } else {
        updateSaveStatus(storyId, 'error', response.statusText);
    }
}